module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = NNns
// module chunks = 1